import {memo} from 'react';

import {Form} from 'react-final-form';

import FormField from '~/shared/components/FormField';
import {
  FieldWrapper,
  FormWrapper,
  LoginFormFieldsWrapper,
  HeaderText,
  StyledErrorText,
} from '~/shared/components/loginStyled';
import FormPieInput from '~/shared/components/FormField/FormInput/FormPieInput';
import PieButton from '~/shared/theme/pie/PieButton';

import OAuthSection from './OAuthSection';
import {LoginProvider} from './consts';

const LoginForm = ({
  onSubmitEmail,
  openFacebook,
  loginText,
  loginProvider,
  requireCaptcha,
  initialValues,
  setFocusElementRef,
  resErrors,
  setResErrors,
  t,
  openProviderScreen,
  openLoginScreen,
  onSubmitWithGoogleConnect,
  isRedirectedToStepRef,
  fromCheckout,
}) => {
  return (
    <>
      <Form
        onSubmit={onSubmitEmail}
        initialValues={initialValues}
        validateOnBlur
        render={({handleSubmit}) => (
          <FormWrapper isLogin onSubmit={handleSubmit}>
            <HeaderText id="modal-title">{t('login_form_header')}</HeaderText>
            <LoginFormFieldsWrapper>
              <FieldWrapper>
                <FormField
                  {...{
                    name: 'email',
                    placeholder: t('what_is_your_email'),
                    type: 'email',
                    required: true,
                    requiredErrorText: 'we_need_an_email_to_get_things_moving',
                    render: FormPieInput,
                    isPieStyle: true,
                    inputProps: {
                      autoComplete: 'email',
                      onKeyUp: () => {
                        if (!resErrors) {
                          return;
                        }

                        setResErrors(null);
                      },
                    },
                    className: 'white-border-on-contrast',
                  }}
                />
              </FieldWrapper>
              {resErrors && <StyledErrorText>{resErrors}</StyledErrorText>}
            </LoginFormFieldsWrapper>
            <PieButton
              variant="primaryLarge"
              ref={setFocusElementRef}
              requireCaptcha={requireCaptcha}
              data-test="login-submit"
              type="submit"
            >
              {loginText || t('lets_go')}
            </PieButton>
          </FormWrapper>
        )}
      />
      {
        loginProvider === LoginProvider.TENBIS && (
          <OAuthSection
            onSubmitWithGoogleConnect={onSubmitWithGoogleConnect}
            openProviderScreen={openProviderScreen}
            openLoginScreen={openLoginScreen}
            openFacebook={openFacebook}
            isRedirectedToStepRef={isRedirectedToStepRef}
            fromCheckout={fromCheckout}
          />
        )
      }
    </>
  );
};

export default memo(LoginForm);
